import React, { FunctionComponent } from 'react';
import type { RecruitmentShowBottomItemTagsProps } from './types';
import type { Hashtag } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowBottomItemTagsProps & {
  hashtags: Hashtag[];
};

export const Presentation: FunctionComponent<Props> = ({
  title,
  recruitmentId,
  isStopped,
  dataCategory,
  dataValue,
  hashtags,
  isPreview
}) => {
  if (hashtags.length === 0) return null

  return (
    <div className="recruitment__show__bottom__wrapper__content">
      <h2 className="mainTitle">{title}</h2>
      <div className="recruitment__show__bottom__wrapper__content__wordList gtm-recruitment_navigation-view-count" data-event-name='recruitment_navigation on screen' data-category={isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent} data-value={dataValue.recruitmentTags}>
        {hashtags.map((tag) => (
          <a
            key={tag.name}
            href={`/tags/${tag.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
            {...(!isPreview && {
              'data-event': 'click',
              'data-category': isStopped
                ? dataCategory.stopRecruitmentContent
                : dataCategory.recruitmentContent,
              'data-value': dataValue.recruitmentTags
            })}
          >
            {tag.name}
          </a>
        ))}
      </div>
    </div>
  );
};
